import * as React from "react";
import { Query } from "react-apollo";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { withToastManager } from "react-toast-notifications";

// Context API
import { AppContextConsumer } from "../ContextProvider";

// GraphQL
import GetUserDetails from "../../GraphQL/Queries/GetUserDetails";

// Presentational/UI
import GlobalModal from "../GlobalModal";
// import Loader from "../Loader/DotLoader";
import EditProfileForm from "./EditProfileForm";

// Styled elements
import { Avatar, Wrapper } from "./StyledElements";

// Themes
import { Images } from "../../Themes";

// Utils
import { AUTH_USER_TOKEN } from "../../Utils/LocalStorage";
import { getUserId } from "../../Utils/Helpers";

const userId = getUserId().userId;

import "./index.css";

class Header extends React.Component<{ pageTitle: string; toastManager: any }> {
  state = {
    modal: false,
    dropdownOpen: false
  };

  toggle = (): void => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  };

  // Close modal
  closeModal = (): void => {
    this.setState({
      modal: false
    });
  };

  // Open modal
  openModal = (): void => {
    this.setState({
      modal: true,
      dropdownOpen: !this.state.dropdownOpen
    });
  };

  // Log out/Sign out
  handleLogout = (): void => {
    window.localStorage.removeItem(AUTH_USER_TOKEN);
    window.location.replace("/sign-in");
  };

  // success notification
  toastNotification = (message: string) => {
    this.props.toastManager.add(message, {
      appearance: "success",
      autoDismiss: true
    });
  };

  render() {
    let { pageTitle } = this.props;
    pageTitle = !pageTitle || pageTitle === "" ? "" : pageTitle;
    return (
      <AppContextConsumer>
        {context => {
          const sideBarOpen = !context ? false : context.state.drawerOpen;

          return (
            <Query query={GetUserDetails} variables={{ id: userId }}>
              {({ loading, error, data }) => {
                if (loading) {
                  // return <Loader />;
                }
                if (error) {
                  return <div>There was a problem loading the user data</div>;
                }
                const user = !data || !data.User ? {} : data.User;

                return (
                  <Wrapper open={sideBarOpen}>
                    <GlobalModal
                      toggleModal={this.closeModal}
                      title="My Profile"
                      modalDisplay={
                        <EditProfileForm
                          closeModal={this.closeModal}
                          notification={this.toastNotification}
                          userId={userId}
                          user={user}
                        />
                      }
                      modal={this.state.modal}
                    />
                    <span>{pageTitle}</span>
                    <Dropdown
                      className="avatar-dropdown"
                      isOpen={this.state.dropdownOpen}
                      toggle={this.toggle}
                    >
                      <DropdownToggle
                        tag="span"
                        onClick={this.toggle}
                        data-toggle="dropdown"
                        aria-expanded={this.state.dropdownOpen}
                      >
                        <Avatar
                          style={{
                            backgroundImage: `url(${Images.defaultAvatar})`
                          }}
                        />
                      </DropdownToggle>
                      <DropdownMenu>
                        <div
                          onClick={() => this.openModal()}
                          className="avatar-dropdown-menu-item dropdown-menu-item-border-bottom"
                        >
                          My Profile
                        </div>
                        <div
                          onClick={this.handleLogout}
                          className="avatar-dropdown-menu-item"
                        >
                          Sign Out
                        </div>
                      </DropdownMenu>
                    </Dropdown>
                  </Wrapper>
                );
              }}
            </Query>
          );
        }}
      </AppContextConsumer>
    );
  }
}

export default withToastManager(Header);



// WEBPACK FOOTER //
// ./src/Components/Header/index.tsx